import { data } from 'others/game/gameData';

export default {
    diamond: (count, isGodFather)=>({
        role: isGodFather ? data?.roles.GodFather : data?.roles.Thief,
        value: count 
    }),
    role: (role)=>role
}